import { apiConfig } from '@nomiss/configs';
import { parseApiErrorResponse } from './api-request.util';
import {
  buildApiHeaders,
  fetchWithAuthRecovery,
  resolveAccessToken,
} from './sdk-client';

export type UserProfileV2 = {
  id: string;
  email: string;
  fullName: string;
  phone: string | null;
  profilePhotoId: string | null;
  profilePhotoUrl: string | null;
  isActive: boolean;
  isEmailVerified: boolean;
  emailVerificationExpiresAt: string | null;
  mfaEnabled: boolean;
  roles: string[];
  createdAt: string;
};

async function usersRequest<T>(
  path: string,
  init?: RequestInit,
  accessToken?: string | null,
): Promise<T> {
  const token = accessToken ?? resolveAccessToken();
  const headers = buildApiHeaders({
    'Content-Type': 'application/json',
    ...(init?.headers as Record<string, string> | undefined),
  });

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetchWithAuthRecovery(`${apiConfig.baseUrl}${path}`, {
    ...init,
    headers,
  });

  if (!response.ok) {
    throw await parseApiErrorResponse(response, 'Users API failed');
  }

  const json = (await response.json()) as { data: T } | T;
  return typeof json === 'object' && json !== null && 'data' in json
    ? (json as { data: T }).data
    : (json as T);
}

export async function getMyProfileV2(
  accessToken?: string | null,
): Promise<UserProfileV2> {
  return usersRequest<UserProfileV2>('/v2/users/me', undefined, accessToken);
}
